<template>
    <div>
        <TableInformation1 :leftDescriptionTable="leftDescriptionTable" :rightDescriptionTable="rightDescriptionTable"></TableInformation1>
        <div class="table-responsive mb-5">
            <table class="table table-sm table-bordered">
                <thead>
                    <tr>
                        <th scope="col" class="text-center font-weight-bold">No</th>
                        <th scope="col" class="text-center font-weight-bold">MATERIAL</th>
                        <th scope="col" class="text-center font-weight-bold">DESCRIPTION</th>
                        <th scope="col" class="text-center font-weight-bold bg-grey">ABC Indicator</th>
                        <th scope="col" class="text-center font-weight-bold bg-grey">Reorder Point</th>
                        <th scope="col" class="text-center font-weight-bold bg-grey">Maximum</th>
                        <th scope="col" class="text-center font-weight-bold bg-grey">LAST UPDATE</th>
                        <th scope="col" class="text-center font-weight-bold bg-light-yellow">ABC Indicator</th>
                        <th scope="col" class="text-center font-weight-bold bg-light-yellow">Reorder Point</th>
                        <th scope="col" class="text-center font-weight-bold bg-light-yellow">Maximum</th>
                        <th style="width: 1%;" scope="col" class="text-center font-weight-bold">Reorder Point Gap</th>
                        <th scope="col" class="text-center font-weight-bold">Maximum Gap</th>
                    </tr>
                </thead>
                <tbody v-for="(item, index) in items" :key="index">
                    <tr>
                        <th scope="row" class="py-2 text-center">{{ index + 1 }}</th>
                        <td class="text-center py-2">{{ item?.material_code }}</td>
                        <td class="py-2">{{ item?.material_description }}</td>
                        <td class="text-center py-2">{{ item?.abc_indicator }}</td>
                        <td class="text-center py-2">{{ item?.rop }}</td>
                        <td class="text-center py-2">{{ item?.eoq }}</td>
                        <td class="text-center py-2">{{ '02 Januari 2025' }}</td>
                        <td class="text-center py-2">{{ item?.abc_indicator_calculate }}</td>
                        <td class="text-center py-2">{{ item?.rop_calculate }}</td>
                        <td class="text-center py-2">{{ item?.eoq_calculate }}</td>
                        <td class="text-center py-2"
                            :class="item?.rop_calculate - item?.rop < 0 ? 'bg-light-red' : 'bg-light-green'">{{
                                item?.rop_calculate - item?.rop }}</td>
                        <td class="text-center py-1"
                            :class="item?.eoq_calculate - item?.eoq < 0 ? 'bg-light-red' : 'bg-light-green'">{{
                                item?.eoq_calculate - item?.eoq }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import TableInformation1 from './TableInformation1.vue';

export default {
    name: 'StockCalcTableResult',
    components: {
        TableInformation1
    },
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            leftDescriptionTable: [{lable: 'Existing', bg: 'bg-grey'},{lable: 'Calculator Recomendation', bg: 'bg-light-yellow'}],
            rightDescriptionTable: []
        }
    },
    methods: {
        formatTanggal(value) {
            if (!value) return '-';
            return moment(value).format('D MMMM YYYY');
        }
    }
}
</script>